<div class="layout-column task-relations-popup">

  <div class="layout-row layout-align-space-between-center header">
    <div class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="relation" classSize="md" fill="#484848"></bringoz-icon>
      <span class="br-body-1 font-weight-600" translate>Relation</span>
    </div>
    <bringoz-button type="tertiary" size="fit" (onClick)="close()">
      <bringoz-icon iconName="close" class="secondary-100"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="flex layout-column bringoz-table">

    <div class="header-container">
      <div class="layout-row layout-align-start-center tr text-uppercase">
        <div class="th col-type" translate>Type</div>
        <div class="th col-route-id" translate>Route ID</div>
        <div class="th col-service-id" translate>Service ID</div>
        <div class="th col-status" translate>Status</div>
        <div class="th col-eta" translate>ETA</div>
        <div class="th col-agent" translate>Agent name</div>
      </div>
    </div>

    <div *ngIf="loading" class="rows-area layout-row layout-align-center-center">
      <app-bringoz-circular-progress></app-bringoz-circular-progress>
    </div>

    <div *ngIf="!loading && !rows.length" class="rows-area layout-row layout-align-center-center">
      <span class="br-body-2 empty-state-text" translate>TASK_RELATIONS_EMPTY</span>
    </div>

    <div *ngIf="!loading && rows.length" class="rows-area body-container">
      <div *ngFor="let row of rows" class="layout-row layout-align-start-center tr">
        <div class="td col-type">
          <div class="layout-row layout-align-start-center gap-5 relation-type-badge"
               [class.blocked-type]="row.isBlocked"
               [class.related-type]="!row.isBlocked">
            <bringoz-icon [iconName]="row.isBlocked ? 'relation-blocked' : 'relation-related'" classSize="sm"></bringoz-icon>
            <span class="text-ellipsis">{{ ('taskRelationTypeLabel.' + row.type) | translate }}</span>
          </div>
        </div>

        <div class="td col-route-id text-ellipsis">
          <app-bringoz-state-link *ngIf="row.details.routeId; else noRouteId"
                                  [state]="'routes'"
                                  [params]="{routeIds: [row.details.routeId]}"
                                  [text]="row.details.routeId"
                                  (linkClick)="close()">
          </app-bringoz-state-link>
          <ng-template #noRouteId>---</ng-template>
        </div>

        <div class="td col-service-id text-ellipsis">
          <app-bringoz-state-link [state]="row.details.taskPurpose === 'Operation' ? 'service.operation.info' : 'service.delivery.info'"
                                  [params]="{id: row.details.serviceId}"
                                  [permission]="'services.get'"
                                  [text]="row.details.serviceDisplayId || row.details.serviceId"
                                  (linkClick)="close()">
          </app-bringoz-state-link>
        </div>

        <div class="td col-status">
          <app-bringoz-status-tag [status]="row.details.status" [isSmall]="true"></app-bringoz-status-tag>
        </div>

        <div class="td col-eta layout-row layout-align-start-center gap-5">
          <bringoz-icon iconName="timer-outline" classSize="md" fill="#484848"></bringoz-icon>
          <span class="text-ellipsis">{{ row.details | bringozDate:'eta':true }}</span>
        </div>

        <div class="td col-agent text-ellipsis">
          <app-agent-link *ngIf="row.details.agentId; else noAgent"
                          [agentId]="row.details.agentId"
                          [agentName]="row.agentName | userName"
                          (linkClick)="close()">
          </app-agent-link>
          <ng-template #noAgent>---</ng-template>
        </div>
      </div>
    </div>

  </div>

</div>
